import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ChartDataSets, ChartOptions } from "chart.js";
import { Color, Label } from "ng2-charts";

import { ZoneComponent } from "@/shared-module/components";
import { RadarChartDatasource } from "@/shared-module/models";
import { DialogService } from "@/shared-module/services";

@Component({
  selector: "app-decisionradarchart",
  templateUrl: "decisionradarchart.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class DecisionRadarChartComponent implements ZoneComponent, OnInit {
  @ViewChild("template", { static: true }) template;
  data: RadarChartDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @Input("data") set setdata(_data: RadarChartDatasource) {
    this.data = _data;
    this.refresh();
  }

  public chartData: ChartDataSets[] = [];
  public chartColors: Color[] = [];
  public chartLegend = true;
  public chartType = "radar";
  private chartSeries: RadarChartDatasource["series"] = [];
  public chartOptions: ChartOptions = {
    legend: {
      labels: {
         generateLabels: (chart) => {
          return (chart.data.datasets || []).map((dataset, i) => ({
            text: dataset.label as string,
            fillStyle: dataset.borderColor as string,
            strokeStyle: dataset.borderColor as string,
            lineWidth: 2,
            datasetIndex: i,
          }));
        },
      },
    },
    tooltips: {
      callbacks: {
        title: (tooltipItems, chartData) => {
          const tooltipItem = tooltipItems?.[0];
          const datasetIndex = tooltipItem?.datasetIndex;
          const pointIndex = tooltipItem?.index;

          if (datasetIndex == null || pointIndex == null) {
            return "";
          }

          const measure = chartData?.labels?.[pointIndex];
          const measureLabel = Array.isArray(measure) ? measure.join(" ") : `${measure ?? ""}`;
          const serieName = chartData?.datasets?.[datasetIndex]?.label ?? "";

          if (measureLabel && serieName) {
            return `${measureLabel} - ${serieName}`;
          }

          return measureLabel || `${serieName}`;
        },
        label: (tooltipItem, data) => {
          const datasetIndex = tooltipItem.datasetIndex;
          const pointIndex = tooltipItem.index;

          if (
            datasetIndex == null ||
            pointIndex == null ||
            !this.chartSeries?.[datasetIndex]?.yValues?.[pointIndex]
          ) {
            return "";
          }

          return this.chartSeries[datasetIndex].yValues[pointIndex].yLabel;
        },
      },
    },
    scale: {
        angleLines: {
            display: true,
            color: "rgba(255, 255, 255, 0.35)",
            lineWidth: 1
        },
        gridLines: {
            color: "rgba(255, 255, 255, 0.35)",
            lineWidth: 1
        },
        ticks: {
            display: false,
            min: 0,
            max: 6
        }
    }
   };
  public chartLabels: Label[] = [];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService
  ) {}

  private getSerieStyle() {
    return {
      borderWidth: 3,
      pointRadius: 3,
      pointHoverRadius:  5,
      backgroundOpacity: 0.35,
      borderOpacity: 1,
    };
  }

  zoom() {
    this.dialogService.setZoomInfo(this.data.zoomInfo);
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.refresh();
 }

    refresh() {
        this.chartData = [];
        this.chartColors = [];
        this.chartLabels = [];

        if (!this.data) {
          return;
        }

        this.chartLabels = this.data.dimensions || [];

        this.chartSeries = (this.data.series || [])
          .filter((s) => !!s && !!s.yValues && s.yValues.length > 0)
          .reverse();

        this.chartSeries.forEach((s) => {
            const serieStyle = this.getSerieStyle();
            const dataset = [];
            s.yValues.forEach((v) => {
              dataset.push(v.y);
            });
            const colorValue = s.color || "54, 162, 235";

            // tslint:disable-next-line:object-literal-shorthand
            const ds = {
              data: dataset,
              label: s.caption || "",
              fill: true,
              borderWidth: serieStyle.borderWidth,
              pointRadius: serieStyle.pointRadius,
              pointHoverRadius: serieStyle.pointHoverRadius,
            };
            const color = {
              backgroundColor: "rgba(" + colorValue + ", " + serieStyle.backgroundOpacity + ")",
              borderColor: "rgba(" + colorValue + ", " + serieStyle.borderOpacity + ")",
              pointBackgroundColor: "rgba(" + colorValue + ", 1)",
              pointHoverBackgroundColor: "rgba(" + colorValue + ", 1)",
            };

            this.chartData.push(ds);
            this.chartColors.push(color);
          });
    }
 }
